import './App.css';
import Header from './components/Header';
import LandingHero from './components/LandingHero';
import ShortBio from './components/ShortBio';
import WorkExperience from './components/WorkExperience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <link rel="preconnect" href="https://fonts.googleapis.com"/>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
      <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Cutive+Mono&family=Raleway:wght@400&family=Righteous&family=Roboto+Mono:wght@300&display=swap" rel="stylesheet"></link>
      <Header />
      <LandingHero />
      <ShortBio />
      <Skills />
      <WorkExperience />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
